import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Callback from './pages/Callback';
import Home from './pages/Home';
import GenerateDraft from './pages/GenerateDraft';
import PersonalizedDraft from './pages/PersonalizedDraft';
import OptimizeForSpam from './pages/OptimizeForSpam';
import RedemptionPage from "./pages/RedemptionPage";
import SettingsPage from "./pages/SettingsPage";
import DraftList from './pages/DraftList';
import ContactUs from './pages/ContactUs';
import DisplayDrafts from "./pages/DisplayDrafts";
import OnboardingWizard from "./pages/OnboardingWizard"
import BulkUrlProcessor from "./pages/BulkUrlProcessor"
import EmailCampaignManager from "./pages/EmailCampaign"
import SESInsights from "./pages/EmailCampaignResults"
import ABTest from "./pages/ABTesting"
import CreditPlan from "./pages/CreditPlan"
import Checkout from "./pages/Checkout"
import OrderSummary from "./pages/OrderSummary"
import Invoices from "./pages/Invoices"
import FAQ from "./pages/FAQ";  
import NotFound from './pages/NotFound'; // Import your 404 component
import Unsubscribe from "./pages/Unsubscribe";
import DfyServiceSection from "./pages/DoneForYou";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import BlogList from "./pages/BlogList";
import BlogPage from "./pages/BlogPage";
import ClientDiscoverySurvey from "./pages/survey";


import TopMenu from './components/TopMenu';
import ProtectedRoute from './ProtectedRoute';
import ProtectedLayout from './components/ProtectedLayout'; // Import the new layout
import { AuthProvider } from './AuthContext';

function App() {
  return (
    <AuthProvider>
      <div>
        {/* Top Menu */}
        <TopMenu />

        {/* Main Content */}
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/displayDrafts" element={<DisplayDrafts />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/leads" element={<DfyServiceSection />} />
          <Route path="/unsubscribe" element={<Unsubscribe/>} />
          <Route path="/terms" element={<Terms/>} />
          <Route path="/blogs" element={<BlogList/>} />
          <Route path="/blogPage" element={<BlogPage/>} />
          <Route path="/privacy" element={<Privacy/>} />
          <Route path="/survey" element={<ClientDiscoverySurvey/>} />


          {/* Protected Routes */}
          <Route
            path="/dash"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                <EmailCampaignManager />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/generateDraft"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <GenerateDraft />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />
             <Route
            path="/ABdrafts"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <ABTest/>
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <EmailCampaignManager />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />
        <Route
            path="/emailResults"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <SESInsights/>
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/personalizeDraft"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <PersonalizedDraft />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/makePersuasive"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <MakePersuasive />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          /> */}
           <Route
            path="/optimizeForSpam"
            element={
              <ProtectedRoute>
                <ProtectedLayout>
                  <OptimizeForSpam />
                </ProtectedLayout>
              </ProtectedRoute>
            }
          /> 
          
          <Route
            path="/redeem"
            element={
              <ProtectedRoute>
                <RedemptionPage />
              </ProtectedRoute>
              }
            />

          <Route
            path="/multilinkedin"
            element={
              <ProtectedRoute>
                <BulkUrlProcessor/>
              </ProtectedRoute>
              }
            />    

        <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
              }
            />

        <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingWizard/>
              </ProtectedRoute>
              }
            />  

        <Route
            path="/creditPlans"
            element={
              <ProtectedRoute>
                <CreditPlan/>
              </ProtectedRoute>
              }
            /> 
          <Route
            path="/allInvoices"
            element={
              <ProtectedRoute>
                <Invoices/>
              </ProtectedRoute>
              }
            /> 

         <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout/>
              </ProtectedRoute>
              }
            />    

         <Route
            path="/orderSummary"
            element={
              <ProtectedRoute>
                <OrderSummary/>
              </ProtectedRoute>
              }
            />            
            

        <Route
            path="/drafts"
            element={
              <ProtectedRoute>
                <DraftList />
              </ProtectedRoute>
              }
            /> 
         {/* 404 Route */}
         <Route path="*" element={<NotFound />} />       
        </Routes>

       
      </div>
    </AuthProvider>
  );
}

export default App;
